// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b356588a","239":"e4206053","455":"086dc1f8","795":"19e40720"}[chunkId] + ".chunk.js";
};